import React, {useEffect} from 'react';
//import {Alert, Row, Col } from 'react-bootstrap';
//import Actions, { DispatchAction } from '../actions';
import { connect } from 'react-redux';
import { versionInfo } from '../utils/CommonUtil';
import { Navbar, Nav, ListGroup } from 'react-bootstrap';
import MsgModal from '../container/MsgModal';
import { setMsgModal } from '../actions/AuthAction';
import { Modal, Button, Row, Col, Card, Form, Container } from 'react-bootstrap';


//function Footer(props) {
  /**
 * Creates a new Footer.
 * @class
 */
const Footer = (props) => {
  /** @function
 * @name showModal */
  const showModal = (msgTitle, msgBody) => {
    props.setMsgModal({
      "title": msgTitle,
      "message": msgBody,
      "show": true
    });
  }
  /** @function
 * @name hideModal */
  const hideModal = () => {
    props.setMsgModal({
      "title": "",
      "message": "",
      "show": false
    });
  }

  useEffect(()=>{
    hideModal()
  }, [])

/*const contactus_text = <p>
                        Welcome to Naumi Fashions<br/>
                        B2B ORDERING PLATFORM<br/>                       
                        CA - 221, CA Block, Sector 1,<br/>
                        Bidhannagar, Kolkata, West Bengal<br/>
                        9002004196 / 9547242580
                       </p>;

const aboutus_text = <p>Welcome to Naumi Fashions<br/>
                        Online Fashion Store<br/>
                        B2B ORDERING PLATFORM
                      </p>;
*/

  return (
    <footer>
      { //<p>
        //{versionInfo()} &copy; 2020 <strong><a href="http://wizardcomm.net">WizardComm</a> - <a href="http://uvanij.com">uVanij.com</a></strong>
        //</p>       
        <div className="footer-wrapper">
          <Row className="ml-0 mr-0">
          <Col xs={{ span: 12, order: 2 }} md={{ span: 6, order: 1 }}>
          <small className="w-100-mob d-block-mob text-center-mob">
            &copy; 2020 Copyright &nbsp;<strong><a href="http://wizardcomm.net">WizardComm</a> - <a href="http://uvanij.com">uVanij.com</a></strong>
          </small>
          </Col>
          <Col xs={{ span: 12, order: 1 }} md={{ span: 6, order: 2 }}>
          <nav className="p-0 w-100-mob d-block-mob text-center-mob">
            <ul className="mb-0 pl-0">
              <li><a href="#" onClick={() => showModal(props.footerdata[1].title, props.footerdata[1].htmlData)}>Contact Us</a></li>
              <li><a href="#" onClick={() => showModal(props.footerdata[0].title, props.footerdata[0].htmlData)}>About Us</a></li>
              <li><a href="#" onClick={() => showModal(props.footerdata[2].title, props.footerdata[2].htmlData.concat("<br/><p>").concat(props.termsandcondition).concat("</p>"))}>Terms & Condition</a></li>
            </ul>
          </nav>
          </Col>
          </Row>
          {props.modal && props.modal.show && <MsgModal show={props.modal.show}
            title={props.modal.title} message={props.modal.message} closeAction={hideModal} />}
        </div>
      }
    </footer>
  );

}

const mapStateToProps = state => ({
  modal: state.AuthData.modal,
  termsandcondition: state.HomeData.termsncondnord,
  footerdata: state.HomeData.footers,
  name: state.UserData.name,
  phone: state.UserData.phone,
  email: state.UserData.email,
  query: ''
});

export default connect(mapStateToProps, { setMsgModal })(Footer);

